import { render, staticRenderFns } from "./catalog-used.vue?vue&type=template&id=55c257fc&"
import script from "./catalog-used.vue?vue&type=script&lang=js&"
export * from "./catalog-used.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Makes: require('/var/www/components/makes/makes.vue').default,FilterDesktop: require('/var/www/components/filter/filter-desktop.vue').default,FilterSort: require('/var/www/components/filter/filter-sort.vue').default,Baner: require('/var/www/components/baner/baner.vue').default,Services: require('/var/www/components/services/services.vue').default})
